import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/Global-Services/common.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ExcelUploadService } from 'src/app/Global-Services/excel-upload.service';
import { FteFinanceUplodPopUpComponent } from 'src/app/Module/Pages/fte-finance-uplod-pop-up/fte-finance-uplod-pop-up.component';
import { MatDialog } from '@angular/material/dialog';
import { NgModel } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';


@Component({
  selector: 'app-view-fterecords',
  templateUrl: './view-fterecords.component.html',
  styleUrls: ['./view-fterecords.component.css'],
  providers: [CommonService],
  standalone: false,
})
export class ViewFTERecordsComponent implements OnInit {
  filteredEmployeeSingle: any [] =[];
  filteredPartnerSingle: any []= [];
  filteredManagerSingle: any [] = [];
  EmployeeName: string[];
  ManagerName: string[];
  PartnerName: string[];
  reverse = false;
  IsSLHR = false;
  sortkey: any;
  ViewFTERecordsList: any[];
  ParamID: any;
  CurrUserGPN = '';
  PageNumber = 1;
  DataList: any;
  EmployeeList = {
    Employee: null,
    EmployeeGPN: null
  };
  ManagerList = {
    Manager: null
  };
  PartnerList = {
    Partner: null
  };
  boolReturn: any;
  LabelName: any;
  IsExport: boolean;
  IsAdmin: boolean;
  ErrorMessage = [];
  FTERecordsList = {
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    ID: '',
    FTEID: '',
    EmpGPN: '',
    EmpName: '',
    EmpTitle: '',
    EmpLocationID: '',
    EmpLocationText: '',
    EmpContractEndDateFrom: '',
    EmpContractEndDateTo: '',
    EmpCouncelorGPN: '',
    CouncelorName: '',
    EmpManagerGPN: '',
    ManagerName: '',
    EmpPartnerGPN: '',
    PartnerName: '',
    RequestStatusID: '',
    RequestStatusDesc: '',
    CreatedOnFrom: '',
    CreatedOnTo: '',
    LastIncrementDateFrom: '',
    LastIncrementDateTo: '',
    EmpEmail: '',
    ServiceLineID: '',
    ServiceLineText: '',
    CouncelorActionOnFrom: '',
    CouncelorActionOnTo: '',
    PartnerActionOnFrom: '',
    PartnerActionOnTo: '',
    IDList: ''
  };
  LocationList: any[];
  StatusList: any[];
  ServiceLineList: any[];
  TitleList: any[];
  IsCounsellor = false;
  IsPartner = false;
  Roles = [];
  href: any;
  @ViewChild('txtRecordID') txtRecordID?: NgModel; //Added by Utkarsh for CR_2311_0209
  @ViewChild('txtEmailID') txtEmailID?: NgModel; //Added by Utkarsh for CR_2311_0209
  @ViewChild('txtCouncelor') txtCouncelor?: NgModel;  //Added by Utkarsh for CR_2311_0209

  constructor(public route: ActivatedRoute, private confirmBox: ConfirmationService, public ExcelUpload: ExcelUploadService,
    public gService: CommonService, public dialog: MatDialog, public datepipe: DatePipe, private gVariable: GlobalVariable, private _Location: Location, private router: Router) { }

  ErrorMassage: any[];

  ngOnInit() {
    // this.href = this._Location.path();
    // this.gService.userAuthentication(this.href);
    this.gVariable.User = this.gService.getUserDetails('zero');
    this.CurrUserGPN = this.gVariable.User.UserGPN;
    this.Roles = this.gVariable.User._ApplicationRole.split(',');

    this.IsAdmin = this.Roles.indexOf('Admin') > -1 ? true : false;
    this.IsCounsellor = this.Roles.indexOf('IsCounsellor') > -1 ? true : false;
    this.IsPartner = this.Roles.indexOf('IsPartner') > -1 ? true : false;
    this.IsSLHR = this.Roles.indexOf('IsSLHR') > -1 ? true : false;

    this.ParamID = this.route.snapshot.paramMap.get('ParamID');
    this.GetSearchResult();
    this.GetLocation();
    this.GetServiceLine();
    this.GetTitle();
    this.GetKeyWordByKeyWordType('RequestStatus');
    this.filteredEmployeeSingle = [];
    this.filteredPartnerSingle = [];
    this.filteredManagerSingle = [];
    this.ShowLabel();
  }
  onFTERecordClick(FTEID: any) {
    this.router.navigate(['/View/FTEDetails/' + FTEID]);
  }
  GetKeyWordByKeyWordType(Value: any) {
    this.gService.GetKeyWordByKeyWordType(Value).subscribe((data: any) => {
      if (Value === 'RequestStatus') {
        this.StatusList = data;
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }
  ShowLabel() {
    if (this.ParamID == 1) {
      this.LabelName = "Pending for Renewal";
    }
    if (this.ParamID == 2) {
      this.LabelName = "Pending for Approval";
    }
    if (this.ParamID == 3) {
      this.LabelName = "Pending for Closure";
    }
    if (this.ParamID == 4) {
      this.LabelName = "View All Records";
    }
    //added by vedha bethi on 10-jun-2021 for CR_2103_0066
    if (this.ParamID == 5) {
      this.LabelName = "Pending with Finance Team";
    }
    //end by vedha bethi on 10-jun-2021 for CR_2103_0066

    //Added By Akash Agrawal For CR_2501_0010
    if (this.ParamID == 6) {
      this.LabelName = "Pending to be Initiated";
    }
    //Ended By Akash Agrawal For CR_2501_0010
  }
  GetEmpSearch(event: any, isGPNFilter: boolean = false) {   //Modified by Utkarsh for CR_2311_0209
    this.EmployeeName = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmpSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data.length > 0) {
          this.EmployeeName = [];
          this.EmployeeName = data;
          if (isGPNFilter) {
            this.filteredEmployeeSingle = this.filterFilterEmpByGPN(query, this.EmployeeName);
          } else {
            this.filteredEmployeeSingle = this.filterFilterEmp(query, this.EmployeeName);
          }
        } else {
          this.EmployeeName = [];
          this.filteredEmployeeSingle = [];
        }
      },
        (err: HttpErrorResponse) => {
          this.EmployeeName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  GetManagerSearch(event: any) {
    this.ManagerName = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetManagerSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data.length > 0) {
          this.ManagerName = [];
          this.ManagerName = data;
          this.filteredManagerSingle = this.filterFilterManager(query, this.ManagerName);
        } else {
          this.ManagerName = [];
          this.filteredManagerSingle = [];
        }
      },
        (err: HttpErrorResponse) => {
          this.ManagerName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  GetPartnerSearch(event: any) {

    this.PartnerName = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetPartnerSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        if (data.length > 0) {
          this.PartnerName = [];
          this.PartnerName = data;
          this.filteredPartnerSingle = this.filterFilterPartner(query, this.PartnerName);
        } else {
          this.PartnerName = [];
          this.filteredPartnerSingle = [];
        }
      },
        (err: HttpErrorResponse) => {
          this.PartnerName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }


  SetSelectedEmpGPN(event: any) {
    this.FTERecordsList.EmpName = event.value.EmpName;
    //this.FTERecordsList.EmpGPN = event.EmpGPN;
  }

  SetSelectedEmpGPN2(event: any) {  //Added by Utkarsh for CR_2311_0209
    this.FTERecordsList.EmpGPN = event.value.EmpGPN;
  }

  SetSelectedManager(event: any) {
    this.FTERecordsList.ManagerName = event.value.EmpName;
    this.FTERecordsList.EmpManagerGPN = event.value.EmpGPN;
  }

  SetSelectedPartner(event: any) {
    this.FTERecordsList.PartnerName = event.value.EmpName;
    this.FTERecordsList.EmpPartnerGPN = event.value.EmpGPN;
  }

  OnClearSendUser() {
    this.EmployeeList.Employee = null;
    this.EmployeeName = null;
    this.FTERecordsList.EmpName = null;
  }

  OnClearSendUser2() {
    this.EmployeeList.EmployeeGPN = null;
    this.EmployeeName = null;
    this.FTERecordsList.EmpGPN = null;
  }

  OnClearManager() {
    this.ManagerList.Manager = null;
    this.ManagerName = null;
    this.FTERecordsList.ManagerName = null;
    this.FTERecordsList.EmpManagerGPN = null;
  }

  OnClearPartner() {
    this.PartnerList.Partner = null;
    this.PartnerName = null;
    this.FTERecordsList.PartnerName = null;
    this.FTERecordsList.EmpPartnerGPN = null;
  }

  filterFilterEmp(query: any, EmployeeList: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < EmployeeList.length; i++) {
      const Emp = EmployeeList[i];
      if (Emp.EmpFullName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
        filtered.push(Emp);
      }
    }
    return filtered;
  }

  filterFilterEmpByGPN(query: any, EmployeeList: any[]): any[] { //Added by Utkarsh for CR_2311_0209
    const filtered: any[] = [];
    for (let i = 0; i < EmployeeList.length; i++) {
      const Emp = EmployeeList[i];
      if (Emp.EmpGPN.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
        filtered.push(Emp);
      }
    }
    return filtered;
  }

  filterFilterManager(query: any, ManagerList: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < ManagerList.length; i++) {
      const Emp = ManagerList[i];
      if (Emp.EmpFullName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
        filtered.push(Emp);
      }
    }
    return filtered;
  }


  filterFilterPartner(query: any, PartnerList: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < PartnerList.length; i++) {
      const Emp = PartnerList[i];
      if (Emp.EmpFullName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
        filtered.push(Emp);
      }
    }
    return filtered;
  }

  GetSearchResult() {
    this.ErrorMessage = [];

    if ((this.FTERecordsList.CreatedOnFrom != null && this.FTERecordsList.CreatedOnFrom != '') && (this.FTERecordsList.CreatedOnTo != null && this.FTERecordsList.CreatedOnTo != '')) {
      if (this.FTERecordsList.CreatedOnFrom > this.FTERecordsList.CreatedOnTo) {
        this.ErrorMessage.push({ message: 'Creation Date(From) cannot be greater than Creation Date(To).' });
      }
    }
    if ((this.FTERecordsList.CouncelorActionOnFrom != null && this.FTERecordsList.CouncelorActionOnFrom != '') && (this.FTERecordsList.CouncelorActionOnTo != null && this.FTERecordsList.CouncelorActionOnTo != '')) {
      if (this.FTERecordsList.CouncelorActionOnFrom > this.FTERecordsList.CouncelorActionOnTo) {
        this.ErrorMessage.push({ message: 'Councelor Sub. Date(From) cannot be greater than Councelor Sub. Date(To).' });
      }
    }
    if ((this.FTERecordsList.PartnerActionOnFrom != null && this.FTERecordsList.PartnerActionOnFrom != '') && (this.FTERecordsList.PartnerActionOnTo != null && this.FTERecordsList.PartnerActionOnTo != '')) {
      if (this.FTERecordsList.PartnerActionOnFrom > this.FTERecordsList.PartnerActionOnTo) {
        this.ErrorMessage.push({ message: 'Partner Action Date(From) cannot be greater than Partner Action Date(To).' });
      }
    }
    if ((this.FTERecordsList.LastIncrementDateFrom != null && this.FTERecordsList.LastIncrementDateFrom != '') && (this.FTERecordsList.LastIncrementDateTo != null && this.FTERecordsList.LastIncrementDateTo != '')) {
      if (this.FTERecordsList.LastIncrementDateFrom > this.FTERecordsList.LastIncrementDateTo) {
        this.ErrorMessage.push({ message: 'Last Increment Date(From) cannot be greater than Last Increment Date(To).' });
      }
    }
    if ((this.FTERecordsList.EmpContractEndDateFrom != null && this.FTERecordsList.EmpContractEndDateFrom != '') && (this.FTERecordsList.EmpContractEndDateTo != null && this.FTERecordsList.EmpContractEndDateTo != '')) {
      if (this.FTERecordsList.EmpContractEndDateFrom > this.FTERecordsList.EmpContractEndDateTo) {
        this.ErrorMessage.push({ message: 'Contract End Date(From) cannot be greater than Contract End Date(To).' });
      }
    }
    if (this.txtRecordID && this.txtRecordID.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Record ID.' });
    }
    if (this.txtCouncelor && this.txtCouncelor.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Councelor.' });
    }
    if (this.txtEmailID && this.txtEmailID.invalid) {
      this.ErrorMessage.push({ message: 'Please enter valid Email ID.' });
    }

    if (this.ErrorMessage.length > 0) {
      return;
    }
    this.IsExport = false;
    this.gService.GetFTEDetailsDataView(this.CurrUserGPN, this.ParamID, this.FTERecordsList, this.IsExport, this.IsAdmin).subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.FTERecordsList.TopRecord = data[0]['TopRec'];
          this.FTERecordsList.TotalRecord = data[0]['TotRec'];
          this.FTERecordsList.RecordFrom = data[0]['RecordFrom'];
          this.FTERecordsList.RecordTo = parseFloat(data[0]['RecordFrom']) + (data.length - 1);
          this.FTERecordsList.TotalPageCount = data[0]['TotalPageCount'];
          this.ViewFTERecordsList = data;
        } else {
          this.ViewFTERecordsList = data;
          this.FTERecordsList.TopRecord = 0;
          this.FTERecordsList.TotalRecord = 0;
          this.FTERecordsList.RecordFrom = 0;
          this.FTERecordsList.RecordTo = 0;
          this.FTERecordsList.TotalPageCount = 0;
          this.FTERecordsList.currentPage = 1;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetLocation() {
    this.gService.GetLocation().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.LocationList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetServiceLine() {

    this.gService.GetServiceLine().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ServiceLineList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  GetTitle() {

    this.gService.GetTitle().subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.TitleList = data;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  blockSpecialChar(event: any) {  //Added by Utkarsh for CR_2311_0209
    try {
      let k;

      if (event.key !== undefined) {
        k = event.key.charCodeAt(0);
      } else {
        // For older browsers that do not support event.key
        document.all ? k = event.keyCode : k = event.which;
      }

      // Allow alphabets (both uppercase and lowercase), space, backspace, and digits
      return ((k >= 65 && k <= 90) || (k >= 97 && k <= 122) || k === 8 || k === 32 || (k >= 48 && k <= 57) || k === 45);
    }
    catch (error) {
      console.log(error);
      return;
    }
  }

  ResetResult() {
    this.FTERecordsList.FTEID = '';
    this.FTERecordsList.EmpGPN = '';
    this.FTERecordsList.EmpName = '';
    this.FTERecordsList.EmpTitle = '';
    this.FTERecordsList.EmpLocationID = '';
    this.FTERecordsList.EmpLocationText = '';
    this.FTERecordsList.EmpContractEndDateFrom = '';
    this.FTERecordsList.EmpContractEndDateTo = '';
    this.FTERecordsList.EmpCouncelorGPN = '';
    this.FTERecordsList.CouncelorName = '';
    this.FTERecordsList.EmpManagerGPN = '';
    this.FTERecordsList.ManagerName = '';
    this.FTERecordsList.EmpPartnerGPN = '';
    this.FTERecordsList.PartnerName = '';
    this.FTERecordsList.RequestStatusID = '';
    this.FTERecordsList.RequestStatusDesc = '';
    this.FTERecordsList.CreatedOnFrom = '';
    this.FTERecordsList.CreatedOnTo = '';
    this.FTERecordsList.LastIncrementDateFrom = '';
    this.FTERecordsList.LastIncrementDateTo = '';
    this.FTERecordsList.EmpEmail = '';
    this.FTERecordsList.ServiceLineID = '';
    this.FTERecordsList.ServiceLineText = '';
    this.FTERecordsList.CouncelorActionOnFrom = '';
    this.FTERecordsList.CouncelorActionOnTo = '';
    this.FTERecordsList.PartnerActionOnFrom = '';
    this.FTERecordsList.PartnerActionOnTo = '';
    this.EmployeeList.Employee = null;
    this.EmployeeList.EmployeeGPN = null; //Added by Utkarsh for CR_2311_0209
    this.ManagerList.Manager = null;
    this.PartnerList.Partner = null;
    this.GetSearchResult();
  }

  sort(keyname: any) {
    this.sortkey = keyname;   // set the sortKey to the param passed
    this.reverse = !this.reverse; // if true make it false and vice versa
  }

  setPage(PageNumber: any) {
    this.FTERecordsList.currentPage = PageNumber;
    this.GetSearchResult();
  }
  PreviousPage() {
    this.FTERecordsList.currentPage = this.FTERecordsList.currentPage - 1;
    this.GetSearchResult();
  }
  NextPage() {
    this.FTERecordsList.currentPage = this.FTERecordsList.currentPage + 1;
    this.GetSearchResult();
  }
  firstPage() {
    this.FTERecordsList.currentPage = 1;
    this.GetSearchResult();
  }
  lastPage() {
    this.FTERecordsList.currentPage = this.FTERecordsList.TotalPageCount;
    this.GetSearchResult();
  }
  range(count: any) {
    const ratings = [];
    let TotalPage = count;
    const Start = this.FTERecordsList.currentPage - 1;
    if (count > 5) {
      TotalPage = this.FTERecordsList.currentPage + 4;
      if (TotalPage > this.FTERecordsList.TotalPageCount) {
        TotalPage = this.FTERecordsList.currentPage + (this.FTERecordsList.TotalPageCount - this.FTERecordsList.currentPage);
      }
    }
    for (let i = Start; i < TotalPage; i++) {
      ratings.push(i);
    }
    return ratings;
  }

  ExportToExcel() {
    this.FTERecordsList.IDList = '';
    this.IsExport = true;
    for (var i = 0; i < this.ViewFTERecordsList.length; i++) {
      if (this.ViewFTERecordsList[i].checked) {
        if (this.FTERecordsList.IDList == '') {
          this.FTERecordsList.IDList = this.ViewFTERecordsList[i].ID;
        }
        else {
          this.FTERecordsList.IDList += ',' + this.ViewFTERecordsList[i].ID
        }
      }
    }
    this.gService.GetFTEDetailsDataView(this.CurrUserGPN, this.ParamID, this.FTERecordsList, this.IsExport, this.IsAdmin).subscribe((data: any) => {
      if (data != null) {
        if (data.length > 0) {
          this.ExcelUpload.exportAsExcelFile(data, 'FTE_List');
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit() {
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to Exit?');
    if (this.boolReturn === false) {
      return;
    }
    this.router.navigate(['/INFTE/home']);
  }
  //added by vedha bethi on 15-jun-2021

  OpenUploadDialog() {
    this.FTERecordsList.IDList = '';
    for (var i = 0; i < this.ViewFTERecordsList.length; i++) {
      if (this.ViewFTERecordsList[i].checked) {
        if (this.FTERecordsList.IDList == '') {
          this.FTERecordsList.IDList = this.ViewFTERecordsList[i].ID;
        }
        else {
          this.FTERecordsList.IDList += ',' + this.ViewFTERecordsList[i].ID
        }
      }
    }
    const dialogRef = this.dialog.open(FteFinanceUplodPopUpComponent,
      {
        width: '45%',
        data: { userGPN: this.CurrUserGPN, FTERecordsList: this.FTERecordsList, IsAdmin: this.IsAdmin }
      });
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }
  ChangeDateFormat(event: MatDatepickerInputEvent<Date>,type: string) {
    const d = event.value; // Get the Date object from the event
    // Format the date as "YYYY-MM-DDT00:00:00"
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1 to get the correct month
    const day = d.getDate().toString().padStart(2, '0');
    const conversionCycleDate = `${year}-${month}-${day}T00:00:00`;
    if(type == 'CreatedOnFrom'){
      this.FTERecordsList.CreatedOnFrom = conversionCycleDate;
    }
    else if(type == 'CreatedOnTo'){
      this.FTERecordsList.CreatedOnTo = conversionCycleDate;
    }
    else if(type == 'CouncelorActionOnFrom'){
      this.FTERecordsList.CouncelorActionOnFrom = conversionCycleDate;
    }
    else if(type == 'CouncelorActionOnTo'){
      this.FTERecordsList.CouncelorActionOnTo = conversionCycleDate;
    }
    else if(type == 'PartnerActionOnFrom'){
      this.FTERecordsList.PartnerActionOnFrom = conversionCycleDate;
    }
    else if(type == 'PartnerActionOnTo'){
      this.FTERecordsList.PartnerActionOnTo = conversionCycleDate;
    }
    else if(type == 'EmpContractEndDateFrom'){
      this.FTERecordsList.EmpContractEndDateFrom = conversionCycleDate;
    }
    else if(type == 'EmpContractEndDateTo'){
      this.FTERecordsList.EmpContractEndDateTo = conversionCycleDate;
    }
    else if(type == 'LastIncrementDateFrom'){
      this.FTERecordsList.LastIncrementDateFrom = conversionCycleDate;
    }
    else if(type == 'LastIncrementDateTo'){
      this.FTERecordsList.LastIncrementDateTo = conversionCycleDate;
    }
  }
}
